import { fetchCookieCountFromApi, fetchCountFromApi } from "@modules/bookmarks/entries/entries-api.ts"
import { Cookie } from "@modules/util/Cookie.ts"

export async function updateMerkzettelStateInMenuForDevice(isMobile: boolean, count: number) {
    const bookmarkEntriesCountCookie = new Cookie("bookmarkEntriesCount", {
        path: "/",
        domain: SiteInfo.cookieDomain,
    })

    bookmarkEntriesCountCookie.value = { count: count }
    bookmarkEntriesCountCookie.expires = Cookie.getExpireDate(300)

    if (isMobile) {
        appendMerkzettelStateInMenuForMobile(count)
    } else {
        appendMerkzettelStateInMenuForPc(count)
    }
}

export async function appendMerkzettelStateInMenuForPc(count: number) {
    const anchor = document.querySelector(".merkz-btn-menu")
    if (!anchor) {
        return
    }

    if (count > 0) {
        anchor.classList.add("has-items")
    } else {
        anchor.classList.remove("has-items")
    }

    const counter = anchor.querySelector(".merkzettel-counter")
    if (count && counter) {
        counter.textContent = count.toString()
    }
}

export async function appendMerkzettelStateInMenuForMobile(count: number) {
    const btn = document.querySelector(".merkz-btn-menu")
    const counterEl = btn?.querySelector(".merkzettel-counter")

    if (counterEl) {
        counterEl.textContent = count.toString()
    }

    if (btn) {
        if (count > 0) {
            btn.classList.add("has-items")
        } else {
            btn.classList.remove("has-items")
        }
    }
}

export const updateMerkzettelStateInMenu = async (resetCookie = false): Promise<void> => {
    let bookmarkEntriesCount = 0
    if (userData.isLoggedIn) {
        const bookmarkEntriesCountCookie = new Cookie("bookmarkEntriesCount", {
            path: "/",
            domain: SiteInfo.cookieDomain,
        })

        if (resetCookie) {
            bookmarkEntriesCountCookie.value = {}
        }

        if (bookmarkEntriesCountCookie.value?.count !== undefined) {
            bookmarkEntriesCount = Number.parseInt(bookmarkEntriesCountCookie.value.count)
        } else {
            await fetchCountFromApi(userData.userId)
                .then((entriesCount) => {
                    bookmarkEntriesCount = entriesCount
                })
                .catch(() => {
                    bookmarkEntriesCount = 0
                })
            bookmarkEntriesCountCookie.value = { count: bookmarkEntriesCount }
            bookmarkEntriesCountCookie.expires = Cookie.getExpireDate(300)
        }

        updateMerkzettelStateInMenuForDevice(SiteInfo.isMobileDevice, bookmarkEntriesCount)
    } else {
        const cookieBookmarkEntriesCountCookie = new Cookie("cookieBookmarkEntriesCount", {
            path: "/",
            domain: SiteInfo.cookieDomain,
        })

        if (resetCookie) {
            cookieBookmarkEntriesCountCookie.value = {}
        }

        if (cookieBookmarkEntriesCountCookie.value?.count !== undefined) {
            bookmarkEntriesCount = Number.parseInt(cookieBookmarkEntriesCountCookie.value.count)
        } else {
            await fetchCookieCountFromApi()
                .then((entriesCount) => {
                    bookmarkEntriesCount = entriesCount
                })
                .catch(() => {
                    bookmarkEntriesCount = 0
                })
            cookieBookmarkEntriesCountCookie.value = { count: bookmarkEntriesCount }
            cookieBookmarkEntriesCountCookie.expires = Cookie.getExpireDate(3600 * 24 * 30)
        }

        updateMerkzettelStateInMenuForDevice(SiteInfo.isMobileDevice, bookmarkEntriesCount)
    }
}
